export const FLAGGED_GENERATORS_KEY = 'flagged-generators'
